import * as React from 'react';
import { useZoneConfiguration } from './useZoneConfiguration';

/** @deprecated */
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function Zone(_ref) {
  var zoneType = _ref.zoneType,
    renderZoneItems = _ref.renderZoneItems,
    zoneContext = _ref.zoneContext,
    contractData = _ref.contractData;
  var contractDataWithFallback = contractData !== null && contractData !== void 0 ? contractData : zoneContext;
  var zoneInstances = useZoneConfiguration({
    zoneType: zoneType,
    zoneContractData: contractDataWithFallback
  });
  var renderer = renderZoneItems !== null && renderZoneItems !== void 0 ? renderZoneItems : defaultZoneRenderChildren;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderer(zoneInstances)
  });
}
function defaultZoneRenderChildren(zoneItems) {
  return zoneItems.map(function (_ref2) {
    var zone = _ref2.zone,
      children = _ref2.children;
    return /*#__PURE__*/_jsx(React.Fragment, {
      children: children
    }, zone.key);
  });
}